import React, { useEffect, useState } from 'react'
import { Box, Image, Stack } from '@chakra-ui/react'
import Logo from "../../assets/images/app_logo.svg";
import DashboardIcon from '../../assets/images/dashboardBorrower.svg';
import DashboardWhiteIcon from '../../assets/images/dashboardBorrowerWhite.svg';
import * as routesNames from '../../constants/routes'
import { Link, useLocation } from 'react-router-dom'

const sideBarOptions = [
  {
    id: 1,
    menuName: 'Dashboard',
    link: routesNames.RECOVERYDASHBOARD,
    menuIcon: DashboardIcon,
    menuIconActive: DashboardWhiteIcon,
  },
]


function SidebarRecovery() {

  const location = useLocation();
  const [menuId, setMenuId] = useState(null)
  
  useEffect(() => {
    const menuItem = sideBarOptions.find((item) => item.link === location.pathname);
    if (menuItem) {
      setMenuId(menuItem.id);
    }
  }, [location.pathname]);

  const handleMenu = (item) => {
    setMenuId(item)
  }

  return (
    <div>
      <Box className='sidebar_wrapper' >
        <Link to={routesNames.INVESTERDASHBOARD}>
          <Image src={Logo} alt='logo' className='app_logo' />
        </Link>
        <Stack className="menu_box">
          {sideBarOptions?.map((item) => {
            return (
              <Link key={item.id} to={item.link} onClick={() => handleMenu(item.id)}
                className={item.id === menuId ? 'active_menu_item menu_item font-poppins' : 'menu_item font-poppins'} >
                <Image src={item.id === menuId ? item.menuIconActive : item.menuIcon} className="icon_size" />
                {item.menuName}
              </Link>
            )
          })}
        </Stack>
      </Box>

    </div>
  )
}

export default SidebarRecovery